<template>
    <div class="row text-start justify-content-center" v-for="(i, index) in rows" :key="i">
        <div class="col-md-3 mt-4" v-for="j in vehiclesList.slice(0+(index*3),3+(index*3))" :key="j">
            <CardVehicle :vehicle="j"/>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import CardVehicle from '../components/CardVehicle.vue'

let apiUrl = `https://www.nova.avtoprevoznistvo-topler.eu/api/vehicles.php`;

export default {
    name: "VehiclesCards",
    components:{
        CardVehicle
    },
    data() {
        return {
            vehiclesList: null,
            vehicleslistcut: null,
            rows: null
        };
    },
    mounted() {
    try {
      axios.get(apiUrl).then((response) => {
        this.vehiclesList = response.data;
        this.rows = Math.ceil(this.vehiclesList.length / 3);
        console.log(this.vehiclesList);
      });
    } catch (err) {
      throw new Error(err);
    }
  },

}
</script>